import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(function Select(
  { className, ...props },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn(
        'w-full rounded-xl border border-white/10 bg-ink-900/80 px-3 py-2 text-sm text-slate-100 outline-none transition focus:border-accent-500',
        className,
      )}
      {...props}
    />
  );
});

